// extracted by mini-css-extract-plugin
module.exports = {"main":"about__main___3J0j2","title":"about__title___35OOK","item":"about__item___7QcYU","msg":"about__msg___1teRj","secTitle":"about__secTitle___2WIhp"};